// extracted by mini-css-extract-plugin
export default {"pageHeroWrapper":"RCsYsg","heroContent":"yWHR4A"};